import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { confirmPayment } from "../api/payment";
import { getOrder } from "../api/order";
import { useCartSummary } from "../context/CartContext";

/**
 * 토스 결제창 인증 완료 후 돌아오는 성공 콜백 페이지(successUrl).
 * 쿼리파라미터(paymentKey, orderId, amount)를 서버로 그대로 전달해 실제 승인을 마쳐야
 * 결제가 완료된다 (여기 도달했다고 결제가 끝난 것이 아니라, 인증만 끝난 상태).
 */
export default function CheckoutSuccessPage() {
  const [params] = useSearchParams();
  const { refresh: refreshCartBadge } = useCartSummary();

  const [status, setStatus] = useState("confirming"); // confirming | done | error
  const [error, setError] = useState("");
  const [order, setOrder] = useState(null);

  useEffect(() => {
    const paymentKey = params.get("paymentKey");
    const orderId = params.get("orderId");
    const amount = Number(params.get("amount"));
    const orderGroupId = window.sessionStorage.getItem("onetak_last_order_group_id");
    const guestPhone = window.sessionStorage.getItem("onetak_last_guest_phone") || undefined;

    if (!paymentKey || !orderId || !amount) {
      setStatus("error");
      setError("결제 정보가 올바르지 않습니다.");
      return;
    }

    confirmPayment({ paymentKey, orderId, amount })
      .then((res) => {
        if (!res.success) {
          setStatus("error");
          setError(res.message || "결제 승인에 실패했습니다.");
          return;
        }
        refreshCartBadge();
        if (orderGroupId) {
          return getOrder(Number(orderGroupId), guestPhone).then((orderRes) => setOrder(orderRes.data));
        }
      })
      .then(() => setStatus((s) => (s === "error" ? s : "done")))
      .catch((err) => {
        setStatus("error");
        setError(err.response?.data?.message || "결제 승인 처리 중 오류가 발생했습니다.");
      });
  }, [params, refreshCartBadge]);

  return (
    <div className="page checkout-result-page">
      {status === "confirming" && <p className="text-sub">결제를 확인하고 있습니다...</p>}

      {status === "error" && (
        <>
          <h1 className="page-title">결제 확인 실패</h1>
          <p className="error">{error}</p>
          <Link to="/cart" className="link-btn">장바구니로 돌아가기</Link>
        </>
      )}

      {status === "done" && (
        <>
          <div className="check">✓</div>
          <h1 className="page-title">주문이 완료되었습니다</h1>
          {order && (
            <div className="order-summary-card">
              <p>주문번호 <strong>{order.orderGroupId}</strong></p>
              {order.discountAmount > 0 && (
                <p>주문할인{order.discountName ? ` (${order.discountName})` : ""} -{Number(order.discountAmount).toLocaleString()}원</p>
              )}
              <p>결제금액 {Number(order.totalAmount).toLocaleString()}원</p>
              <p>배송지 {order.receiverAddress}</p>
            </div>
          )}
          <Link to="/products" className="link-btn">쇼핑 계속하기</Link>
        </>
      )}
    </div>
  );
}
